"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var embeddedContent;
        (function (embeddedContent) {
            var index;
            (function (index) {
                class InitArgs {
                    constructor() {
                        this.linkAction = appn.emptyString;
                        this.url = appn.emptyString;
                        this.title = appn.emptyString;
                    }
                }
                let _initArgs;
                function init(args) {
                    _initArgs = args;
                    addEvents();
                    $('section.content').css('padding', '0px');
                    appn.dialog.showLoading(_initArgs.title);
                    if (_initArgs.linkAction === 'POST') {
                        $('#iframePostForm').submit();
                        return;
                    }
                    $('iframe[name=contentIframe]').prop('src', _initArgs.url);
                    setTimeout(function () {
                        appn.dialog.hideLoading();
                    }, 10000);
                }
                index.init = init;
                function addEvents() {
                    $('iframe[name=contentIframe]').on('load', function () {
                        appn.dialog.hideLoading();
                    });
                }
            })(index = embeddedContent.index || (embeddedContent.index = {}));
        })(embeddedContent = views.embeddedContent || (views.embeddedContent = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
